import * as React from 'react'

import { SidePanelOverlayProvider } from './SidePanelOverlayContext'

const BASE_CLASS =
  'tw:absolute tw:top-0 tw:right-0 tw:w-[400px] tw:h-full tw:bg-background tw:text-foreground tw:border-0 tw:border-l tw:border-solid tw:border-border tw:flex tw:flex-col tw:shadow-[-4px_0_16px_rgba(0,0,0,0.1)]'

interface IProps {
  children: React.ReactNode
  className?: string
  zIndex?: number
  testId?: string
}

export const SidePanel: React.FC<IProps> = ({
  children,
  className,
  zIndex = 100,
  testId,
}) => {
  return (
    <div
      className={className ? `${BASE_CLASS} ${className}` : BASE_CLASS}
      style={{ zIndex }}
      data-testid={testId}
    >
      <SidePanelOverlayProvider>{children}</SidePanelOverlayProvider>
    </div>
  )
}
